import React from 'react'
import CarouselSection from '../Components/CarouselSection'
import AboutSection from '../Components/AboutSection'
import ServiceTabbedSection from '../Components/ServiceTabbedSection'
import MissionSection from '../Components/MissionSection'
import TestimonialsSection from '../Components/TestimonialsSection'


const Home = () => {
    return (
        <div>
            <CarouselSection />
            <ServiceTabbedSection />
            <div className="section-alt-bg">
                <MissionSection />
            </div>
            <AboutSection />
            <div className="section-alt-bg py-2">
               <TestimonialsSection />
            </div>
        </div>
    )
}

export default Home